import { track } from '@vercel/analytics';

// Cookieless analytics via Vercel Web Analytics: no cookies, no personal
// data, no consent banner required. Page views are tracked automatically by
// the <Analytics /> component in main.jsx; this wrapper forwards custom
// events (whitepaper opens/downloads, language switches).
export function trackEvent(name, payload) {
  try {
    track(name, payload);
  } catch {
    /* analytics must never break the app */
  }
}
